var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:[
    {
      'collapse-sidebar': _vm.collapseSidebar
    }
  ],attrs:{"id":"inspire"}},[_c('router-view'),_c('video-ayuda',_vm._b({on:{"cerrar":_vm.cerrarVideoAyuda}},'video-ayuda',_vm.videoAyuda,false)),_c('v-auditoria'),_c('notifications',{attrs:{"group":"general","position":"top right","animation-type":"velocity"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }